module.exports = __webpack_public_path__ + "static/media/31pic.e8cd9027.jpg";